import { use_slice_generation, use_slice_grid2d, use_slice_ui, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { BUTTON__try_app } from '@/pages/_base/buttons/BUTTON__try_app';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { assert_instanceof, assert_record_value } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { useMemo } from 'react';
import { G_BUTTON__generation_clone } from './_buttons/G_BUTTON__generation_clone';
import { G_BUTTON__generation_start } from './_buttons/G_BUTTON__generation_start';
import { G_BUTTON__generation_start_with_new_seeds } from './_buttons/G_BUTTON__generation_start_with_new_seeds';
import { G_BUTTON__generation_stop } from './_buttons/G_BUTTON__generation_stop';
import { G_VIEW__generation_contains_errors } from './_views/G_VIEW__generation_contains_errors';

export function G_BUTTON__generation_view_master() {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current', 'user_task_current']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);
  const { user_settings, is_authorized } = use_slice_user(['user_settings', 'is_authorized']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { global__is_shift_pressed } = use_slice_ui(['global__is_shift_pressed']);

  /*
   * STATE
   */
  const all_cells_generated = useMemo(() => get_all_cells_generated(), [generation_current, grids2d_map]);

  /*
   *
   */

  function get_all_cells_generated() {
    if (generation_current.is_stub()) return false;
    if (!grids2d_map.has(generation_current._id)) return false;

    let grid2d = grids2d_map.get_or_assert(generation_current._id);
    assert_instanceof(grid2d, DTO__grid2d_generation);

    let out = grid2d.cells__get_list().length == grid2d.total_images_amount;

    return out;
  }
  /*
   * RENDERS
   */

  function render_status_adjusting() {
    if (global__is_shift_pressed) return <G_BUTTON__generation_start_with_new_seeds />;
    if (user_settings.generation_autorun) return <G_BUTTON__generation_clone />;

    return all_cells_generated ? <G_BUTTON__generation_clone /> : <G_BUTTON__generation_start />;
  }

  function render_status_stopped() {
    return global__is_shift_pressed ? <G_BUTTON__generation_start_with_new_seeds /> : <G_BUTTON__generation_start />;
  }

  function render_status_in_progress() {
    return <G_BUTTON__generation_stop />;
  }

  function render_button_generation() {
    if (generation_current.is_stub()) return <PLACEHOLDER_bar_line />;

    let views_map: Record<string, JSX.Element> = {};

    if (!is_authorized) return <BUTTON__try_app />; //not authorized
    if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return <PLACEHOLDER_bar_line />;
    if (!generation_current.tool.graph.meta.errors.is_empty()) return <G_VIEW__generation_contains_errors />;

    views_map[ENUM__generation_status.ADJUSTING] = render_status_adjusting();
    views_map[ENUM__generation_status.IN_PROGRESS] = render_status_in_progress();
    views_map[ENUM__generation_status.STOPPED] = render_status_stopped();
    views_map[ENUM__generation_status.LOCKED] = <G_BUTTON__generation_clone />;
    views_map[ENUM__generation_status.ERROR] = render_status_stopped();

    let out = assert_record_value(views_map, generation_current.status);

    return out;
  }

  /*
   * HTML
   */

  return <div className={`h-full flex-1 flex flex-center`}>{render_button_generation()}</div>;
}
